module.exports = __webpack_public_path__ + "static/media/House.de8001ef.svg";